import { useEffect, useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Loader2 } from 'lucide-react';
import { adminApi } from '@/lib/api';

export const AdminLayout = () => {
  const { admin, loading } = useAuth();
  const [fyControl, setFyControl] = useState(null);

  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const res = await adminApi.getFinancialYearControl();
        if (active) setFyControl(res.data || null);
      } catch {
        if (active) setFyControl(null);
      }
    };
    if (!loading && admin) load();
    return () => {
      active = false;
    };
  }, [loading, admin]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FAFAF9] flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#C97A5E]" />
      </div>
    );
  }

  if (!admin) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-[#FAFAF9]">
      <Sidebar />
      <div className="ml-64 transition-all duration-300">
        <Header />
        {['freeze_active', 'closure_confirmed'].includes(String(fyControl?.state || '')) ? (
          <div className="px-8 pt-4">
            <div className="rounded-xl border border-[#F1D39A] bg-[#FFF7E8] px-4 py-3 text-sm text-[#9A6700]">
              Financial year close freeze is active. Transactional actions are blocked until opening balances are completed.
            </div>
          </div>
        ) : null}
        <main className="p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
};
